<template>
  <div
    class="container"
    :style="fileList.length ? 'margin-bottom: -20px;' : ''">
    <ViewFileItem
      v-for="item in fileList"
      :key="item.path"
      :file="item"
      :del="false">
    </ViewFileItem>
  </div>
</template>

<script>
export default {
  props: {
    fileList: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="less">
.container {
  display: flex;
  flex-wrap: wrap;
}
</style>
